import { createStore } from 'vuex'
import user from './modules/user'
import app from './modules/app'
import tagsView from './modules/tags-view'
import permission from './modules/permission'
import getters from './getters'

export default createStore({
  modules: {
    user,
    app,
    tagsView,
    permission
  },
  getters
})